import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
    selector: 'app-consortium',
    templateUrl: './consortium.component.html',
    styleUrls: ['./consortium.component.css'],
    standalone: false
})
export class ConsortiumComponent {

  examList = [

    {
      title: "Consortium of Selective Schools in Essex (CSSE) 11 Plus (11+) Exam 2024, Year 7 Entry – Key Details",
      description: "The Consortium of Selective Schools in Essex (CSSE) is a collaborative group of grammar schools in Essex that work together to administer the 11+ entrance examination for admission to their schools. The CSSE aims to ensure a fair and consistent admissions process for selective schools in Essex, allowing students to be considered for multiple schools within the consortium based on their performance in the entrance exam.",
      image: "assets/images/csse_sch.jpeg",
      route: "csse-schools"
    },

    {
      title:"Redbridge, Essex, Grammar Schools 11 Plus (11+) Exam Information",
      description:"In the London Borough of Redbridge, Essex, there are two well-known grammar schools. Both offer a similarly high level of education and provide a wealth of academic and non-academic opportunities, enabling students to fulfil their ambitions.",
      image:"assets/images/redb-sch.png",
      route:"redbridge-schools"
    },

    {
      title: "Buckinghamshire Grammar School Consortium 11 Plus (11+) Exam Information",
      description: "The Buckinghamshire Grammar School Consortium was established with the purpose of coordinating the 11+ secondary school entrance examination process in Buckinghamshire. Its objective is to ensure a fair and consistent admissions process for all selective grammar schools in the county. Students who take the 11+ entrance exam have the opportunity to be considered for multiple schools within the consortium based on their performance",
      image: "assets/images/bks-sch.jpeg",
      route: "bucks-schools"
    },

    {
      title: "Kent Grammar Schools 11 Plus (11+) Exam Information",
      description: "The Consortium of Selective Schools in Essex (CSSE) is a collaborative group of grammar schools in Essex that work together to administer the 11+ entrance examination for admission to their schools. The CSSE aims to ensure a fair and consistent admissions process for selective schools in Essex, allowing students to be considered for multiple schools within the consortium based on their performance in the entrance exam.",
      image: "assets/images/sch-1.jpg",
      route: "kent"
    },
    {
      title: "Queen Elizabeth’s School, Barnet, 11 Plus (11+) Exam – Key Details 2025",
      description: "Queen Elizabeth’s School (commonly known as QE Boys) is a reputable all-boys school located in the Barnet region of London, known for its long-standing tradition of providing exceptional educational instruction to pupils. Founded in 1573, the school’s extensive campus is nestled in the centre of Barnet, creating a conducive atmosphere for learning and personal growth.",
      image: "assets/images/qe-sch.jpg",
      route: "qe"
    },
    {
      title: "The Henrietta Barnett School 11 Plus (11+) Exam – Key Details 2025",
      description: "The Henrietta Barnett School (HBS) is a highly-regarded all-girls grammar school with academy status, nestled in the scenic Hampstead Garden Suburb, London. Philanthropist Dame Henrietta Barnett established the school in 1911. Her vision for the school was to provide a high-quality education to girls from various backgrounds, thereby promoting social equality and cohesion. ",
      image: "assets/images/hbs-sch.jpg",
      route: "hbs"
    },
    {
      title: "Reading School | Late Transfer (Mid-Year 12+ and 13+) Entry Information",
      description: "Reading School is a grammar school for boys with academy status in Berkshire. Founded as part of Reading Abbey, it is considered one of the oldest schools in the country. Its list of notable alumni includes a Former Prime Minister of the UK, a Victoria Cross recipient and an impressive number of university professors ",
      image: "assets/images/reading-sch.jpg",
      route: "reading"
    },
    {
      title: "Sutton Grammar School 11 Plus (11+) Exam – Key Details 2025",
      description: "Sutton Grammar School is a selective grammar school for boys in Sutton. Operational since 1899, it is regularly featured among the best state secondary schools in London. Sutton Grammar’s alumni list is long and impressive, including authors, inventors, politicians and historians.",
      image: "assets/images/sutton-sch2.jpg",
      route: "sutton"
    },
    {
      title: "Slough Grammar School Consortium 11 Plus (11+) Exam Information",
      description: "Grammar school consortia in the UK are collaborative groups of grammar schools that work together to administer entrance exams for admission to their schools. They are typically formed by a group of grammar schools in a particular area or region, who have come together to create a common entrance examination. ",
      image: "assets/images/slough-sch.jpg",
      route: "slough"
    },
    {
      title: "Bexley Grammar Schools 11 Plus (11+) Exam Information ",
      description: "Grammar school consortia in the UK are collaborative groups of grammar schools that work together to administer entrance exams. They are typically formed by a group of grammar schools in a particular area or region, who have come together to create a common entrance examination. This test is known as the 11+ or eleven plus exam, and is taken by students seeking Year 7 entry into these selective schools.",
      image: "assets/images/bex1.jpg",
      route: "bexley"
    },
    {
      title: "Chelmsford County High School for Girls 11 Plus (11+) Exam, Year 7 Entry ",
      description: "Chelmsford County High School for Girls, situated in Chelmsford, Essex, was established in 1906. The school welcomes female students between the ages of 11 and 18 and is considered one of the most competitive grammar schools in Essex concerning admissions. It was converted to an academy in 2011.",
      image: "assets/images/cchs1.jpg",
      route: "cchsgirls"
    },
    {
      title: "Future Stories Community Enterprise (FSCE): What You Need to Know ",
      description: "Future Stories Community Enterprise Ltd (FSCE) is a non-profit organisation focused on providing children with tailored education and support to help them achieve their full potential. FSCE offers a wide range of services, ",
      image: "assets/images/fsce1.jpg",
      route: "fsce"
    },

    {
      title: "Reading School for Boys 11 Plus (11+) Entrance Exam Information 2025",
      description: "Reading School, situated in Berkshire, is a distinguished boys’ grammar school with academy status. Established as a part of Reading Abbey in 1125, it ranks among England’s oldest schools. Throughout its history, it has continued to uphold its dedication to educational excellence. Currently, Reading School occupies a scenic campus featuring cutting-edge facilities that inspire an atmosphere conducive to learning. ",
      image: "assets/images/readingboys1.jpg",
      route: "readingboys"
    },
    {
      title: "Reading Girls’ School 11 Plus (11+) Exam – Selective Stream Test Information",
      description: "stablished in 1818, Reading Girls’ School is a partially selective, bilateral school for girls in Reading, Berkshire. Approximately 430 girls are educated by 25 staff members. The school is known for its focus on business and enterprise. Students are encouraged to strive for excellence academically and socially and the curriculum offers a broad range of subjects and extra-curricular activities.",
      image: "assets/images/readinggirls1.jpg",
      route: "readinggirls"
    },
    {
      title: "Trafford Grammar Schools Consortium 11 Plus (11+) Exam Information ",
      description: "In the UK, grammar school consortia are cooperative alliances of grammar schools that collaborate to facilitate entrance exams. These consortia are usually established by a cluster of grammar schools within a specific area or region, joining forces to develop a unified entrance examination process.",
      image: "assets/images/tford-sch.jpeg",
      route: "trafford"
    },

    {
      title: "The Latymer School Consortium 11 Plus (11+) Exam Information ",
      description: "The Latymer School is a highly respected, state-funded co-educationalgrammar school located in Edmonton, North London, just a short walk fromEdmonton Green Overground station. ",
      image: "assets/images/latymer-sch.jpeg",
      route: "latymer"
    },


  ];

  images: string[] = [
    'assets/images/sch-1.jpg',
    'assets/images/sch_2.jpg',
    'assets/images/sch-3.png',
    'assets/images/sch-4.jpg',
  ];
  currentIndex = 0;
  interval: any;

  constructor(private router: Router) {
    this.autoSlide();
  }

  goToSlide(index: number) {
    this.currentIndex = index;
  }

  autoSlide() {
    this.interval = setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    }, 3000); // Auto-slide every 3 seconds
  }

  openExam(index:number){
    this.router.navigate([this.examList[index].route])
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
